<wuc-link
    type="secondary"
    [iconRight]="selectedPanel !== selectedPanelEnum.Close ? 'arrow-up-bold' : 'arrow-down-bold'"
    iconSize="xs"
    (click)="onNavigate()"
>
    <ng-container *ngIf="title">{{ title }}</ng-container>
</wuc-link>
